import { Pipe, PipeTransform } from '@angular/core';
import { Match } from '../match.model';
import { IsPreMatchOnlyPipe } from './is-pre-match-only.pipe';

/**
 * A pipe which transforms a [`Match`](../match.model.ts)
 * object into a boolean, representing whether the match is in progress but in a "paused" state, and the match's
 * sport is supported for live updates on this client (verified by using the [`IsPreMatchOnlyPipe`](./is-pre-match-only.pipe.ts)).
 * However, the paused state is not currently supported, so no match can ever be paused. This pipe is a placeholder
 * which, for now, will always return false.
 */
@Pipe({
  name: 'isPaused',
  pure: false,
})
export class IsPausedPipe implements PipeTransform {

  constructor(
    private isPreMatchOnlyPipe: IsPreMatchOnlyPipe,
  ) { }

  /**
	 * A pipe which transforms a [`Match`](../match.model.ts)
	 * object into a boolean, representing whether the match is in progress but in a "paused" state, and the match's
   * sport is supported for live updates on this client (verified by using the [`IsPreMatchOnlyPipe`](./is-pre-match-only.pipe.ts)).
   * However, the paused state is not currently supported, so no match can ever be paused. This pipe is a placeholder
   * which, for now, will always return false.
	 * @param match the `Match` object for the sporting match
	 * @returns `false` in all cases, for now.
	 */
  transform(match: Match): boolean {
    return this && match.LiveData
			&& (false) // TODO add types of delay, including weather etc
			&& !this.isPreMatchOnlyPipe.transform(match);
  }

}
